import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../modules/infra/i18n';
import Modal from '../../../common/Modal';
import PayoutForm from '../containers/PayoutFormContainer';

const PayoutModal = ({ close }) => (
  <Modal
    title={t('register:cash_register.payout_payin_modal_title')}
    close={close}
    showCloseButton
  >
    <PayoutForm closePayoutModal={close} />
  </Modal>
);
PayoutModal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default PayoutModal;
